<template>
  <div class="dataReport">
    <PanelHead title="数据报表" subtitle="DATA REPORT" :exportUrl="dataUrl">
      <el-button class="dataReport__custom-tag" size="mini" slot="customTag" @click="visible=true">自定义指标</el-button>
    </PanelHead>
    <div class="panel-content">
      <h3 class="panel-content__title">数据报表</h3>
      <div class="panel-content__select-wrap">
        <div class="panel-content__select-list">
          <div class="panel-content__select-item">
            <ny-date-range v-model="date" @change="dateChange" :shortcut="true"></ny-date-range>
          </div>
        </div>
        <div class="panel-content__select-list">
          <div class="panel-content__select-item" v-if="platform==='admin'|| platform==='agency'">
            <span class="panel-content__label">广告主</span>
            <up-select
              :data="adr.list"
              v-model="adr.value"
              placeholder="请输入..."
              :filterable="true"
              @change="(value) => changeSelect(value, 'adr')"
            ></up-select>
          </div>
          <div class="panel-content__select-item">
            <span class="panel-content__label">广告组</span>
            <up-select
              :data="order.list"
              v-model="order.value"
              placeholder="请输入..."
              :filterable="true"
              @change="(value) => changeSelect(value, 'order')"
            ></up-select>
          </div>
          <div class="panel-content__select-item">
            <span class="panel-content__label">计划</span>
            <up-select
              :data="ad.list"
              v-model="ad.value"
              placeholder="请输入..."
              :filterable="true"
              @change="(value) => changeSelect(value, 'ad')"
            ></up-select>
          </div>
          <div class="panel-content__select-item">
            <span class="panel-content__label">创意</span>
            <up-select
              :data="creative.list"
              v-model="creative.value"
              placeholder="请输入..."
              :filterable="true"
              @change="(value) => changeSelect(value, 'creative')"
            ></up-select>
          </div>
          <div class="panel-content__select-item">
            <el-button @click="searchData">搜索</el-button>
          </div>
        </div>
        <div class="panel-content__select-list">
          <div class="panel-content__select-item dataReport__dimensions">
            <span class="panel-content__label">维度</span>
            <up-checkbox-group :data="dimensionsDataSelect" v-model="dimensions" @change="searchData"></up-checkbox-group>
          </div>
        </div>
      </div>
      <div class="panel-content__table-wrap">
        <up-table
         class="panel-content__table"
          :page="page"
          pagination
          :width-columns="{ date: '120px'}"
          @up:size-change="sizeChange"
          @up:current-change="currentChange">
        </up-table>
      </div>
    </div>
    <indicator
      v-model="visible"
      :data="options.targets"
      @confirm="onIndicatorConfirm"
      :defaultIndicators="defaultIndicators"
      :use-choose="false"
    ></indicator>
  </div>
</template>

<script>
/**
 * @代理商, 广告主平台复用页面
 * @date 2022-04-18
 */
import { BASE_URL } from '@/global/util/constants';
import qs from 'qs'
import { mapActions, mapGetters, mapState } from 'vuex'
import { formatDate, getDiffDate } from '@/global/util/date'
import Page from '@/global/util/Page';
import { PanelHead, selectMenu, NyTable, NyDateRange, NySelect, Indicator } from '@/global/components'
export default {
  data () {
    return {
      visible: false,
      options: {
        targets: [],
      },
      adr: {
        value: '', // 广告主value
        list: [] // 广告主列表
      },
      order: {
        value: '', // 广告组
        list: [] // 广告组列表
      },
      ad: {
        value: '', // 计划
        list: [] // 计划列表
      },
      creative: {
        list: [], // 创意列表
        value: '' // 创意
      },
      dimensions: ['date_time', 'advertiser_id'], // 维度
      page: new Page(),
      defaultIndicators: ['display_num', 'click_num', 'click_rate', 'total_cost', 'ecpm', 'click_avg_cost'],
      metrics: [],
      dataUrl: '',
      date: [], // 日期插件当前日期
      showBox: false, // 是否展示详情数据的标识
      platform: '', // 当前广告平台名称
      selectType: '', // 详情表的标识
      clickRow: {} // 表格行点击时传的参数
    }
  },
  computed: {
    ...mapGetters({
      userid: 'login/userid'
    }),
    ...mapState('transferEvent', ['dimensionsDataSelect']),
    /*
    dataUrl () {
      let data = {
        user_id: this.userid,
        ader_id: this.adr.value === '' ? '0' : this.adr.value,
        order_id: this.order.value === '' ? '0' : this.order.value,
        ad_id: this.ad.value === '' ? '0' : this.ad.value,
        start_time: this.date[0],
        end_time: this.date[1],
        page: this.page.pageIndex,
        perpage: this.page.pageSize,
        is_export: 1
      }
      return `${BASE_URL}/${this.platform}/data/list?${qs.stringify(data)}`
    }, */
    /* detailUrl () {
      let data = {
        start_time: this.date[0],
        end_time: this.date[1],
        user_id: this.userid,
        ader_id: this.clickRow.ader_id,
        ad_id: this.clickRow.ad_id ? this.clickRow.ad_id : 0,
        order_id: this.clickRow.order_id ? this.clickRow.order_id : 0,
        perpage: this.detailPage.pageSize,
        page: this.detailPage.currentPage,
        granularity: this.granularity,
        is_export: 1
      }
      return `${BASE_URL}/${this.platform}/data/detail?${qs.stringify(data)}`
    } */
  },
  created () {
    // this.userid = 1
    this.platform = this.$router.currentRoute.meta.platform; // 定义标识当前系统的常量
    this.metrics = [...this.defaultIndicators]
    let today = formatDate(new Date())
    this.date[0] = this.date[1] = today
    // 填充广告主下拉菜单
    this.getSelectMenu()
    this.getList()
    this._getCustomTags()
  },
  methods: {
    ...mapActions(['dataReport/options', 'dataReport/table', 'dataReport/detail', 'dataReport/granularity', 'dataReport/getCustomTags']),
    dateChange (date) {
      this.showBox = false
      if (date) {
        this.date = date
      }
      this.getSelectMenu()
      this.getList()
    },
    changeSelect (value, part) {
      if (part === 'adr') {
        this.order.value = ''
        this.ad.value = ''
        this.creative.value = ''
        this.adr.value !== '0' && this.getOptions(this.adr.value, '0', '0', (data) => {
          this.order.list = data
        })
      } else if (part === 'order') {
        this.ad.value = ''
        this.creative.value = ''
        this.order.value !== '0' && this.getOptions(this.adr.value, this.order.value, '0', (data) => {
          this.ad.list = data
        })
      } else if (part === 'ad') {
        this.creative.value = ''
        this.ad.value !== '0' && this.getOptions(this.adr.value, this.order.value, this.ad.value, (data) => {
          this.creative.list = data
        })
      }
    },
    getSelectMenu () {
      // 填充广告主下拉菜单
      if (this.platform === 'admin' || this.platform === 'agency') {
        this.getOptions('0', '0', '0', (data) => {
          this.adr.list = data
        })
      } else { // 填充计划下拉菜单
        this.getOptions('0', '0', '0', (data) => {
          this.order.list = data
        })
      }
    },
    getOptions (adrId, orderId, adId = '', callback) { // 获取下拉菜单数据
      const platformMap = {
        'agency': 'agency_id',
        'ka': 'ader_id',
        'admin': 'user_id',
        'ad-user': 'ader_id'
      }
      this['dataReport/options']({
        platform: this.platform,
        data: {
          start_time: this.date[0],
          end_time: this.date[1],
          ader_id: adrId,
          [platformMap[this.platform]]: this.userid,
          order_id: orderId === '' ? '0' : orderId,
          ad_id: adId === '' ? '0' : adId
        }      }).then(data => {
        if (data && data.code === 1) {
          callback(data.data)
        }
      })
    },
    _getCustomTags() {
      this['dataReport/getCustomTags']({
        platform: this.platform
      }).then(res => {
        this.options.targets = res.data.map(item => {
          return {
            checkAll: false,
            isIndeterminate: false,
            checkValue: [],
            ...item
          }
        })
      })
    },
    getList () { // 获取表格数据
      this.page.loading = true
      let params = {
        user_id: this.userid,
        advertiser_id: this.adr.value === 'all' ? '' : this.adr.value,
        order_id: this.order.value === 'all' ? '' : this.order.value,
        ad_id: this.ad.value === 'all' ? '' : this.ad.value,
        creative_id: this.creative.value === 'all' ? '' : this.creative.value,
        metrics: this.metrics,
        dimensions: this.dimensions,
        start_time: this.date[0],
        end_time: this.date[1],
        page: this.page.currentPage,
        pageSize: this.page.pageSize,
        is_export: 0
      }
      this.$store.dispatch('dataReport/table', {
        platform: this.platform,
        data: params
      }).then((data) => {
        params.is_export = 1
        this.dataUrl = `${BASE_URL}/${this.platform}/data/list?${qs.stringify(params)}`
        this.page.loading = false
        this.page.setPageData(
          {
            header: data.data.header,
            data: data.data.data,
            total: data.data.total
          },
          false
        )
        this.selectType = data.data.id_type
      })
    },
    sizeChange (page) { // 当表格显示条数发生变化是触发的函数
      this.showBox = false
      this.page.pageSize = page.pageSize;
      this.page.currentPage = page.currentPage;
      this.getList();
    },
    currentChange (page) { // 当表格当前页码发生变化是触发的函数
      this.showBox = false
      this.page.currentPage = page.currentPage;
      this.page.pageSize = page.pageSize;
      this.getList();
    },
    searchData () {
      this.page.currentPage = 1;
      this.page.pageSize = 10;
      this.showBox = false
      this.getList()
    },
    onIndicatorConfirm({ indicators }) {
      this.page.header = {}
      this.page.clearData()
      this.metrics = indicators.map(item => item.value)
      this.getList()
    },
  },
  components: {
    PanelHead,
    selectMenu,
    NyTable,
    NyDateRange,
    NySelect,
    Indicator
  }
}
</script>

<style lang="scss">
.dataReport {
  position: relative;
  .mr0 {
    margin-right: 0 !important;
  }
  .tableBox {
    margin-top: 34px;
    .el-table {
      border-top: 1px solid #f1f5fc;
      border-bottom: 1px solid #f1f5fc;
    }
  }
   @include e(dimensions) {
    display: flex;
    align-items: center;
  }
  .success {
    color: #fff;
    background: #3dc1c4;
    border-color: #65cea7;
    padding: 6px 10px;
    margin-left: 5px;
  }
  .el-input__inner:focus {
    border-color: #2f6599;
  }
  .detailInfo {
    position: relative;
    margin-top: 44px;
    background: #fff;
    width: 100%;
    .ps-table {
      box-shadow: none;
    }
    .button__export {
      margin-top: -44px;
    }
  }
  .firstColumn {
    color: #0f1a23;
    cursor: pointer;
  }
  .icon {
    margin-left: 10px;
    color: #02bfc3;
  }
  .el-date-editor {
    margin: 27px 16px 28px 20px;
  }
  .dataReport__custom-tag{
    position: absolute;
    top: 9px;
    right: 88px;
    text-align: center;
    border-radius: 3px 3px;
    cursor: pointer;
  }
}
</style>
